// @ts-nocheck
const CustomerProfileSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default CustomerProfileSkeleton